import { apiRequest } from './util'

export function getZoomUsers() {
  return apiRequest('zoom/users', 'GET');
}